<template>
    <div class="detail-container" v-loading="loading">
        <zm-form>
            <zm-tree :data="dataTree"
                :props="defaultProps"
                key="0"
                @node-click="handleNodeClick"
                :render-content="renderContent">
            </zm-tree>
        </zm-form>
        <zm-form>
            <zm-tree :data="haTree"
                :key="treeKey"
                :props="defaultProps"
                @node-click="handleHANodeClick"
                :expand-on-click-node="false"
                :default-expand-all="treeKey !== 1"
                :render-content="renderContent">
            </zm-tree>
        </zm-form>
        <zm-form v-if="data.operateTopicStatus === 'MIGRATE_TOPIC'">
            <zm-tree :data="migrateTree"
                :key="migrateKey"
                :props="defaultProps"
                @node-click="handleMigrateNodeClick"
                :expand-on-click-node="false"
                :default-expand-all="migrateKey !== 1"
                :render-content="renderContent">
            </zm-tree>
        </zm-form>
        <zm-row>
        <zm-button size="small" type="link" v-if="data.name !== data.url && !showSubscribers" @click="showTable()" style="margin: 10px 0 10px 0" icon="zm-icon-right">subscribers</zm-button>
        <zm-button size="small" type="link" v-if="data.name !== data.url && showSubscribers" @click="showSubscribers = false" style="margin: 10px 0 10px 0" icon="zm-icon-down">subscribers</zm-button>
        <zm-button size="small" type="icon" v-if="data.name !== data.url" icon="zm-icon-download-alt" @click="downloadSubscribers"><i></i></zm-button>
        </zm-row>
        <zm-table :data="list" border class="table-in-detail" @expand-change='tableExpand' v-if="data.name !== data.url && showSubscribers" @cell-click="handelCellClick"
        :init-displayed-column="initDisplayedColumn" :expand-row-keys="expands" :row-key="getRowKeys">
            <!-- <zm-table-column label="subscribers" align="center"> -->
            <zm-table-column prop="expand" type="expand">
                <template slot-scope="props">
                    <subscriber :group="props.row.group" :topicId="topicId"
                        :subscriberPrivateIpAllowStrings="props.row.subscriberPrivateIpAllowStrings"
                        :subscriberPrivateIpDenyStrings="props.row.subscriberPrivateIpDenyStrings"
                        :subscriberPublicIpAllowStrings="props.row.subscriberPublicIpAllowStrings"
                        :subscriberPublicIpDenyStrings="props.row.subscriberPublicIpDenyStrings"
                        @refreshSubscriberList="refreshSubscriberList"></subscriber>
                </template>
            </zm-table-column>
            <zm-table-column prop="mqType" label="mqType" width="105px" align="center" :show-overflow-tooltip="true"></zm-table-column>
            <zm-table-column prop="group" label="group" align="center" :show-overflow-tooltip="true"></zm-table-column>
            <zm-table-column prop="groupId" label="groupId" align="center" :show-overflow-tooltip="true">
                <template slot-scope="scope">
                    <a>{{ scope.row.groupId }}</a>
                </template>
            </zm-table-column>
            <zm-table-column prop="inFlight" label="inFlight" width="105px" align="center"></zm-table-column>
            <zm-table-column prop="remain" label="remain" width="105px" align="center">
                <!-- eslint-disable-next-line -->
                <template slot="header" slot-scope="scope">
                    remain
                    <zm-button class="zm-icon-refresh" type="icon" @click="fetchRemain(true)" title="refresh remain" :loading="remainLoading"></zm-button>
                </template>
                <template slot-scope="scope">
                    <div>{{ scope.row.remain }}</div>
                </template>
            </zm-table-column>
            <zm-table-column prop="threshold" label="threshold" align="center" width="115px"></zm-table-column>
            <zm-table-column prop="dcName" label="dcName" align="center" v-if="data.broadcast"></zm-table-column>
            <zm-table-column prop="url" label="url" align="center" :show-overflow-tooltip="true"></zm-table-column>
            <zm-table-column prop="settingConsumeDelayMs" label="settingConsumeDelayMs" align="center" :show-overflow-tooltip="true" width="200px"></zm-table-column>
            <zm-table-column prop="minWorkingCount" label="minWorkingCount" align="center" :show-overflow-tooltip="true" width="160px"></zm-table-column>
            <zm-table-column prop="shakeType" label="shakeType" align="center" :show-overflow-tooltip="true" width="140px"></zm-table-column>
            <zm-table-column prop="shakeValidPeriodMs" label="shakeValidPeriodMs" align="center" :show-overflow-tooltip="true" width="180px"></zm-table-column>
            <zm-table-column prop="settingCounts" label="settingCounts" align="center" :show-overflow-tooltip="true" width="180px"></zm-table-column>
            <zm-table-column prop="settingReceiveCounts" label="settingReceiveCounts" align="center" :show-overflow-tooltip="true" width="180px"></zm-table-column>
            <zm-table-column prop="settingStatus" label="settingStatus" align="center" :show-overflow-tooltip="true" width="180px"></zm-table-column>
            <zm-table-column prop="consumerClientParams" label="consumerClientParams" align="center" :show-overflow-tooltip="true" width="180px">
                <template slot-scope="scope">
                    {{ scope.row.consumerClientParams ? scope.row.consumerClientParams.name : '' }}
                </template>
            </zm-table-column>
            <zm-table-column prop="discardUnhandledTask" label="discardUnhandledTask" align="center" :show-overflow-tooltip="true" width="180px">
                <template slot-scope="scope">
                    <i :class="scope.row.discardUnhandledTask ? 'zm-icon-ok' : 'zm-icon-close'"></i>
                </template>
            </zm-table-column>
            <zm-table-column prop="timeout" label="timeout" align="center" :show-overflow-tooltip="true" width="180px"></zm-table-column>
            <zm-table-column prop="timeoutIsSuccess" label="timeoutIsSuccess" align="center" :show-overflow-tooltip="true" width="180px">
                <template slot-scope="scope">
                    <i :class="scope.row.timeoutIsSuccess ? 'zm-icon-ok' : 'zm-icon-close'"></i>
                </template>
            </zm-table-column>
            <zm-table-column prop="maxRetryTimes" label="maxRetryTimes" align="center" :show-overflow-tooltip="true" width="180px"></zm-table-column>
            <zm-table-column prop="retryInterval" label="retryInterval" align="center" :show-overflow-tooltip="true" width="180px"></zm-table-column>
            <zm-table-column prop="retryIntervalTimeUnit" label="retryIntervalTimeUnit" align="center" :show-overflow-tooltip="true" width="180px"></zm-table-column>
            <zm-table-column prop="version" label="version" align="center" :show-overflow-tooltip="true" width="180px"></zm-table-column>
            <zm-table-column prop="action" width="190px" align="center">
                <template slot-scope="scope">
                    <zm-button size="small" class="btn-contain" type="icon" title="batch subscribers setting" icon="zm-icon-edit" @click="batchSetSub(scope.row)"></zm-button>
                    <zm-button size="small" class="btn-contain" type="icon" title="set threshold" icon="zm-icon-settings" @click="openThreshold(scope.row)"></zm-button>
                    <zm-button size="small" class="btn-contain" type="icon" title="delete subscription" icon="zm-icon-delete" @click="deleteSub(scope.row)"></zm-button>
                    <zm-button size="small" class="btn-contain" type="icon" title="update subscription ip verify" icon="zm-icon-device-filter" @click="showVerify(scope.row)"></zm-button>
                    <!-- <zm-button size="small" class="btn-contain iconfont icon-resetsettings" type="icon" title="reset topic remain" @click="showReset(scope.row)"></zm-button> -->
                </template>
            </zm-table-column>
            <!-- </zm-table-column> -->
        </zm-table>
        <zm-row>
        <zm-button size="small" type="link" v-if="!data.internal && !showPublishers" @click="showPublisherTable()" style="margin: 0 0 10px 0" icon="zm-icon-right">publishers</zm-button>
        <zm-button size="small" type="link" v-if="!data.internal && showPublishers" @click="showPublishers = false" style="margin: 0 0 10px 0" icon="zm-icon-down">publishers</zm-button>
        <zm-button size="small" type="icon" v-if="!data.internal" icon="zm-icon-download-alt" @click="downloadProducers"></zm-button>
        </zm-row>
        <zm-table :data="dataList" border class="table-in-detail" @expand-change='publisherTableExpand' v-if="!data.internal && showPublishers">
            <zm-table-column label="publishers" align="center">
                <zm-table-column type="expand">
                    <!-- eslint-disable-next-line -->
                    <template slot-scope="props">
                        <publisher :topicId="topicId" v-if="showPublishers"></publisher>
                    </template>
                </zm-table-column>
            <zm-table-column prop="mqType" label="mqType" width="105px" align="center" :show-overflow-tooltip="true"></zm-table-column>
            <zm-table-column prop="leo" label="total" align="center" :show-overflow-tooltip="true">
                <template slot-scope="scope">
                    {{ scope.row.leo }}
                    <zm-button class="zm-icon-refresh" type="icon" @click="refreshLeo" :loading="loadingLeo"
                    title="refresh leo"></zm-button>
                </template>
            </zm-table-column>
            <zm-table-column prop="url" label="url" align="center"></zm-table-column>
            </zm-table-column>
        </zm-table>
        <zm-dialog title="Update Subscription" :visible.sync="thVisible" :append-to-body="true" width="550px">
            <zm-form :model="thForm" label-position="left" ref="form">
                <zm-form-item label="dcName" label-width="100px">
                    <div slot="label">
                        <tip label="dcName" id="topic-detail-dcName"></tip>
                    </div>
                    <zm-input size="small" v-model.trim="thForm.dcName"></zm-input>
                </zm-form-item>
                <zm-form-item label="group" label-width="100px">
                    <div slot="label">
                        <tip label="group" id="topic-detail-group"></tip>
                    </div>
                    <zm-input size="small" v-model.trim="thForm.group" readonly></zm-input>
                </zm-form-item>
                <zm-form-item label="threshold" label-width="100px" prop="threshold">
                    <div slot="label">
                        <tip label="threshold" id="topic-detail-threshold"></tip>
                    </div>
                    <zm-input-number size="small" v-model="thForm.threshold" :min="0"></zm-input-number>
                </zm-form-item>
                <zm-form-item label="settingConsumeDelayMs" prop="settingConsumeDelayMs" label-width="200px">
                    <template slot="label">
                        <tip label="settingConsumeDelayMs" id="topic-detail-settingConsumeDelayMs"></tip>
                    </template>
                    <zm-input-number size="small" v-model="thForm.settingConsumeDelayMs" :min="-1"></zm-input-number>
                </zm-form-item>
                <zm-form-item label="minWorkingCount" prop="minWorkingCount" label-width="200px">
                    <div slot="label">
                        <tip label="minWorkingCount" id="topic-detail-minWorkingCount"></tip>
                    </div>
                    <zm-input-number size="small" v-model="thForm.minWorkingCount" :min="0"></zm-input-number>
                </zm-form-item>
                <zm-form-item label="shakeType" prop="shakeType" label-width="150px">
                    <div slot="label">
                        <tip label="shakeType" id="topic-detail-shakeType"></tip>
                    </div>
                    <zm-radio-group size="small" v-model="thForm.shakeType" :disabled="data.ordered">
                        <zm-radio label="ForceShake"></zm-radio>
                        <zm-radio label="NoShake"></zm-radio>
                        <zm-radio label="AutoShake"></zm-radio>
                    </zm-radio-group>
                </zm-form-item>
                <zm-form-item label="shakeValidPeriodMs" prop="shakeValidPeriodMs" label-width="200px">
                    <div slot="label">
                        <tip label="shakeValidPeriodMs" id="topic-detail-shakeValidPeriodMs"></tip>
                    </div>
                    <zm-input-number size="small" v-model="thForm.shakeValidPeriodMs" :min="0"></zm-input-number>
                </zm-form-item>
                <zm-form-item label="consumerClientParamId" prop="consumerClientParamId" label-width="200px">
                    <div slot="label">
                        <tip label="consumerClientParamId" id="topic-detail-consumerClientParamId"></tip>
                    </div>
                    <zm-select size="small" v-model="thForm.consumerClientParamId" clearable filterable>
                        <zm-option v-for="item in consumerClient" :key="item.id" :value="item.id" :label="item.name"></zm-option>
                    </zm-select>
                </zm-form-item>
                <zm-form-item label-width="0">
                    <zm-checkbox v-model="thForm.discardUnhandledTask">
                        <tip label="discardUnhandledTask" id="topic-detail-discardUnhandledTask"></tip>
                    </zm-checkbox>
                </zm-form-item>
                <zm-form-item label="timeout" prop="timeout" label-width="140px">
                    <div slot="label">
                        <tip label="timeout" id="topic-detail-timeout"></tip>
                    </div>
                    <zm-input-number size="small" v-model="thForm.timeout" :min="0"></zm-input-number>
                </zm-form-item>
                <zm-form-item label-width="0">
                    <zm-checkbox v-model="thForm.timeoutIsSuccess">
                        <tip label="timeoutIsSuccess" id="topic-detail-timeoutIsSuccess"></tip>
                    </zm-checkbox>
                </zm-form-item>
                <zm-form-item label="maxRetryTimes" prop="maxRetryTimes" label-width="140px">
                    <div slot="label">
                        <tip label="maxRetryTimes" id="topic-detail-maxRetryTimes"></tip>
                    </div>
                    <zm-input-number size="small" v-model="thForm.maxRetryTimes" :min="0"></zm-input-number>
                </zm-form-item>
                <zm-form-item label="retryInterval" label-width="140px">
                    <div slot="label">
                        <tip label="retryInterval" id="topic-detail-retryInterval"></tip>
                    </div>
                    <div style="width: 100%">
                        <zm-input-number size="small" v-model="thForm.retryInterval"
                            :min="0" class="number-with-select"></zm-input-number>
                        <zm-select size="small" v-model="thForm.retryIntervalTimeUnit"
                            class="select-with-number">
                            <zm-option value="SECONDS">SECONDS</zm-option>
                            <zm-option value="MINUTES">MINUTES</zm-option>
                            <zm-option value="HOURS">HOURS</zm-option>
                            <zm-option value="DAYS">DAYS</zm-option>
                        </zm-select>
                    </div>
                </zm-form-item>
                <zm-form-item label="version" label-width="140px">
                    <div slot="label">
                        <tip label="version" id="topic-detail-version"></tip>
                    </div>
                    <zm-input-number size="small" v-model="thForm.version" :min="0"></zm-input-number>
                </zm-form-item>
            </zm-form>
            <div slot="footer" class="dialog-footer">
                <zm-button size="small" @click="thVisible = false">Cancel</zm-button>
                <zm-button size="small" type="primary" @click="saveThreshold()" :loading="loading">Submit</zm-button>
            </div>
        </zm-dialog>
        <zm-dialog title="Subscriber Batch Settings" :visible.sync="batchVisible" :append-to-body="true" width="550px">
            <zm-form :model="batchForm" label-position="left" ref="form" label-width="180px">
                <zm-form-item label="group">
                    <div slot="label">
                        <tip label="group" id="topic-detail-subbatch-group"></tip>
                    </div>
                    <zm-input size="small" v-model.trim="batchForm.group" readonly></zm-input>
                </zm-form-item>
                <zm-form-item label="counts" prop="settingCounts">
                    <div slot="label">
                        <tip label="counts" id="topic-detail-counts"></tip>
                    </div>
                    <zm-input-number size="small" v-model="batchForm.settingCounts" :min="0"></zm-input-number>
                </zm-form-item>
                <zm-form-item label="receiveCounts" prop="settingReceiveCounts">
                    <div slot="label">
                        <tip label="receiveCounts" id="topic-detail-receiveCounts"></tip>
                    </div>
                    <zm-input-number size="small" v-model="batchForm.settingReceiveCounts" :min="0"></zm-input-number>
                </zm-form-item>
                <zm-form-item label="status">
                    <div slot="label">
                        <tip label="status" id="topic-detail-status"></tip>
                    </div>
                    <zm-select size="small" v-model="batchForm.settingStatus">
                        <zm-option v-for="item in options" :key="item.value"
                        :label="item.value" :value="item.value"></zm-option>
                        <zm-option label="RESTART" value="RESTART"></zm-option>
                    </zm-select>
                </zm-form-item>
            </zm-form>
            <div slot="footer" class="dialog-footer">
                <zm-button size="small" @click="batchVisible = false">Cancel</zm-button>
                <zm-button size="small" type="primary" @click="batchResetSub()" :loading="resetLoading">Reset</zm-button>
                <zm-button size="small" type="primary" @click="saveBatch()" :loading="saveLoading">Submit</zm-button>
            </div>
        </zm-dialog>
        <zm-dialog title="Topic Describe" :visible.sync="topicDescribeVisible" :append-to-body="true" width="80%" show-close>
            <topicDescribeDetail :channelId="describeForm.channelId" :topicUrl="describeForm.topicUrl" v-if="topicDescribeVisible"></topicDescribeDetail>
        </zm-dialog>
        <zm-dialog title="Group Describe" :visible.sync="groupDescribeVisible" :append-to-body="true" width="80%" show-close>
            <groupDescribeDetail :channelId="describeForm.channelId" :groupId="describeForm.groupId" v-if="groupDescribeVisible" :isTopicDetail="true"></groupDescribeDetail>
        </zm-dialog>
        <zm-dialog :visible.sync="resetVisible" title="Reset Offsets" append-to-body>
            <zm-checkbox size="small" v-model="resetForm.resetToEarliest">resetToEarliest</zm-checkbox>
            <div slot="footer" class="dialog-footer">
                <zm-button size="small" @click="resetVisible = false">Cancel</zm-button>
                <zm-button size="small" type="primary" @click="resetTopicRemain()" :loading="resetOffsetLoading">Reset</zm-button>
            </div>
        </zm-dialog>
        <zm-dialog title="Subscription Ip Verify" :visible.sync="verifyVisible" :append-to-body="true">
            <zm-form :model="verifyForm" label-position="left" ref="verifyForm" label-width="100px">
                <zm-form-item label="group">
                    <div slot="label">
                        <tip label="group" id="topic-detail-verifyForm-group"></tip>
                    </div>
                    <zm-input size="small" v-model.trim="verifyForm.group" readonly></zm-input>
                </zm-form-item>
                <zm-form-item label-width="0">
                    <zm-checkbox v-model="verifyForm.subscriberIpVerify">
                        <tip label="subscriberIpVerify" id="topic-detail-verifyForm-subscriberIpVerify"></tip>
                    </zm-checkbox>
                </zm-form-item>
                <div v-if="verifyForm.subscriberIpVerify">
                <div class="zm-form-item zm-form--label-left"
                v-for="item in ['subscriberPrivateIpAllowStrings', 'subscriberPrivateIpDenyStrings', 'subscriberPublicIpAllowStrings', 'subscriberPublicIpDenyStrings']"
                :key="item">
                    <label class="zm-form-item__label" style="width: 245px;">
                        <tip :label="item" :id="'topic-detail-verifyForm' + item"></tip>
                    </label>
                    <div style="margin-left: 100px;">
                        <zm-tag
                            type=""
                            class="input-tag"
                            :key="tag"
                            v-for="tag in verifyForm[item]"
                            closable
                            :disable-transitions="false"
                            @close="handleClose(tag, item)">
                            {{ tag }}
                        </zm-tag>
                        <zm-input
                            class="input-new-tag"
                            v-if="tagVisible[item]"
                            v-model="tagInput[item]"
                            :ref="'saveTagInput_' + item"
                            size="small"
                            @keyup.enter.native="handleInputConfirm(item)"
                            @blur="handleInputConfirm(item)"
                            >
                        </zm-input>
                        <zm-button size="small" v-else class="button-new-tag" @click="showInput(item)">+</zm-button>
                    </div>
                </div>
                </div>
            </zm-form>
            <div slot="footer" class="dialog-footer">
                <zm-button size="small" @click="verifyVisible = false">Cancel</zm-button>
                <zm-button size="small" type="primary" @click="saveVerify()" :loading="saveLoading">Submit</zm-button>
            </div>
        </zm-dialog>
    </div>
</template>
<script>
import topicDescribeDetail from '../channel/topicDescribeDetail'
import groupDescribeDetail from '../channel/groupDescribeDetail'
import { getTopicById, getTopicRemain, deleteSubscriber,
getUserListById,
getLeo, getHAInfo,
resetTopicRemain,
batchSetSubscribers,
updateSubscriptionIpVerify,
getMigrationInfo,
downloadSubcribers,
downloadProducers,
setThreshold } from '../../api/index'
import { listClient } from '../../api/clientparam'
import subscriber from './subscriber'
import publisher from './publisher'
import tip from 'components/ToolTip/index'
export default {
    name: 'topicDetail',
    props: ['topicId', 'topicName'],
    components: {
        tip,
        subscriber,
        publisher,
        topicDescribeDetail,
        groupDescribeDetail
    },
    data () {
        return {
            initDisplayedColumn: {
                key: 'topicDetail',
                props: ['expand', 'mqType', 'group', 'groupId', 'inFlight', 'remain', 'threshold', 'dcName', 'url', 'settingConsumeDelayMs', 'minWorkingCount', 'shakeType', 'shakeValidPeriodMs', 'action']
            },
            data: {},
            loading: true,
            resetLoading: false,
            saveLoading: false,
            remainLoading: false,
            loadingLeo: false,
            dataTree: [
                {
                    label: '',
                    children: []
                }
            ],
            treeKey: 1,
            migrateKey: 1,
            haTree: [
                {
                    label: 'HAInfo',
                    children: []
                }
            ],
            migrateTree: [
                {
                    label: 'MigrateInfo',
                    children: []
                }
            ],
            advancedFeatureMapTree: [
                {
                    label: 'advancedFeatureMap',
                    children: []
                }
            ],
            broadcastUrlMapTree: [
                {
                    label: 'broadcastUrlMap',
                    children: []
                }
            ],
            defaultProps: {
                children: 'children',
                label: 'label'
            },
            list: [],
            alreadyGetRemain: false,
            dataList: [
                {
                    publishers: [],
                    url: '',
                    leo: '',
                    mqType: ''
                }
            ],
            publishers: [],
            showSubscribers: false,
            showPublishers: false,
            batchVisible: false,
            batchForm: {
                group: '',
                settingCounts: 0,
                settingReceiveCounts: 0,
                settingStatus: '',
                topicId: localStorage.topicId
            },
            consumerClient: [],
            thVisible: false,
            thForm: {
                consumerClientParamId: '',
                discardUnhandledTask: false,
                timeout: '',
                timeoutIsSuccess: false,
                maxRetryTimes: '',
                retryInterval: '',
                retryIntervalTimeUnit: 'MINUTES',
                version: '',
                shakeType: '',
                shakeValidPeriodMs: 0,
                minWorkingCount: 0,
                settingConsumeDelayMs: -1,
                dcName: '',
                topicId: localStorage.topicId,
                group: '',
                threshold: 0
            },
            topicDescribeVisible: false,
            groupDescribeVisible: false,
            describeForm: {
                channelId: '',
                topicUrl: '',
                groupId: ''
            },
            verifyVisible: false,
            verifyForm: {
                topicId: '',
                group: '',
                subscriberIpVerify: false,
                subscriberPrivateIpAllowStrings: [],
                subscriberPrivateIpDenyStrings: [],
                subscriberPublicIpAllowStrings: [],
                subscriberPublicIpDenyStrings: []
            },
            tagVisible: {
                subscriberPrivateIpAllowStrings: false,
                subscriberPrivateIpDenyStrings: false,
                subscriberPublicIpAllowStrings: false,
                subscriberPublicIpDenyStrings: false
            },
            tagInput: {
                subscriberPrivateIpAllowStrings: '',
                subscriberPrivateIpDenyStrings: '',
                subscriberPublicIpAllowStrings: '',
                subscriberPublicIpDenyStrings: ''
            },
            resetVisible: false,
            resetOffsetLoading: false,
            resetForm: {
                group: '',
                topicName: '',
                resetToEarliest: false
            },
            expands: [],
            getRowKeys (row) {
                return row.groupId
            },
            options: [
                // {
                //     disabled: true,
                //     value: 'INITIAL'
                // },
                {
                    disabled: false,
                    value: 'FORBIDDEN'
                },
                {
                    disabled: false,
                    value: 'ALLOWED'
                }
            ]
        }
    },
    created () {
       this.fetchData()
    },
    methods: {
        fetchClient () {
            listClient('CONSUMER').then(response => {
                this.consumerClient = response
            })
        },
        renderTree () {
            this.treeKey += 1
        },
        renderMigrateTree () {
            this.migrateKey += 1
        },
        handleNodeClick (data, node, tree) {
            if (data.label.indexOf('url: ') !== -1) {
                this.describeForm.channelId = this.data.channelId
                this.describeForm.topicUrl = this.data.url
                this.topicDescribeVisible = true
            } else if (this.data.broadcastUrlMap && Object.keys(this.data.broadcastUrlMap).indexOf(data.label.split(':')[0]) !== -1) {
                this.describeForm.channelId = data.label.split(': ')[0]
                this.describeForm.topicUrl = data.label.split(': ')[1]
                this.topicDescribeVisible = true
            }
        },
        handelCellClick (row, column, cell, event) {
            if (column.label === 'groupId') {
                this.describeForm.channelId = row.channelId
                this.describeForm.groupId = row.groupId
                this.groupDescribeVisible = true
            }
        },
        handleHANodeClick (data, node, tree) {
            if (data.label === 'HAInfo') {
            this.loading = true
            getHAInfo(this.topicId).then(response => {
                this.data.topicHAInfo = response
                let hachildren = []
                if (this.data.topicHAInfo.modifiedTime) {
                    this.data.topicHAInfo.modifiedTime = new Date(parseInt(this.data.topicHAInfo.modifiedTime)).toLocaleString()
                }
                this.haTree[0].label = 'HAInfo'
                this.appendContent(hachildren, this.data.topicHAInfo)
                this.haTree[0].children = hachildren
                this.renderTree()
                this.loading = false
            }).catch(() => {
                this.loading = false
            })
            }
        },
        handleMigrateNodeClick (data, node, tree) {
            if (data.label === 'MigrateInfo') {
            this.loading = true
            getMigrationInfo(this.topicId).then(response => {
                this.data.topicMigrateInfo = response
                let migratechildren = []
                this.migrateTree[0].label = 'MigrateInfo'
                if (this.data.topicMigrateInfo) {
                    if (this.data.topicMigrateInfo.createdTime) {
                        this.data.topicMigrateInfo.createdTime = new Date(parseInt(this.data.topicMigrateInfo.createdTime)).toLocaleString()
                    }
                    if (this.data.topicMigrateInfo.modifiedTime) {
                        this.data.topicMigrateInfo.modifiedTime = new Date(parseInt(this.data.topicMigrateInfo.modifiedTime)).toLocaleString()
                    }

                    this.appendContent(migratechildren, this.data.topicMigrateInfo)
                }
                this.migrateTree[0].children = migratechildren
                this.renderMigrateTree()
                this.loading = false
            }).catch(() => {
                this.loading = false
            })
            }
        },
        appendContent (tree, data) {
            for (let item in data) {
                let value = data[item]
                let type = Object.prototype.toString.call(value)
                if (type === '[object String]') {
                    try {
                        let obj = JSON.parse(value)
                        if (typeof obj === 'object' && obj) {
                            type = '[object Object]'
                            value = obj
                        }
                    } catch {
                    }
                }
                if (type === '[object Object]') {
                    let map = {
                        label: item,
                        children: []
                    }
                    this.appendContent(map.children, value)
                    tree.push(map)
                } else {
                    tree.push({ 'label': item + ': ' + value })
                }
            }
        },
        fetchData () {
            this.loading = true
            getTopicById(this.topicId).then(response => {
                this.data = response
                if (!this.data.topicHAInfo) {
                    this.data.topicHAInfo = []
                }
                this.data.createdTime = new Date(parseInt(this.data.createdTime)).toLocaleString()
                this.data.modifiedTime = new Date(parseInt(this.data.modifiedTime)).toLocaleString()
                this.data.lastExpandModifiedTime = new Date(parseInt(this.data.lastExpandModifiedTime)).toLocaleString()
                this.publishers = this.data.publishers
                this.list = this.data.subscribers
                let children = []
                let hachildren = []
                let migratechildren = []
                this.dataTree[0].label = 'details'
                for (let field in this.data) {
                    if (field !== 'advancedFeatureMap' && field !== 'broadcastUrlMap' && field !== 'producerClientParams' &&
                    field !== 'consumerClientParams' && field !== 'subscribers' && field !== 'publishers' &&
                    field !== 'topicHAInfo' && field !== 'topicMigrateInfo' && !(field === 'leo' && !this.data.internal)) {
                        children.push({ 'label': field + ': ' + this.data[field] })
                    } else if ((field === 'producerClientParams' || field === 'consumerClientParams') && this.data[field]) {
                        children.push({ 'label': field + ': ' + this.data[field]['name'] })
                    } else if (field === 'advancedFeatureMap') {
                        for (let item in this.data.advancedFeatureMap) {
                            let advancedFeature = ''
                            for (let feature in this.data.advancedFeatureMap[item]) {
                                if (feature === 'currentValue') {
                                    advancedFeature = this.data.advancedFeatureMap[item][feature]
                                }
                            }
                            this.advancedFeatureMapTree[0].children.push({ 'label': item + ': ' + advancedFeature })
                        }
                        children.push(this.advancedFeatureMapTree[0])
                    } else if (field === 'broadcastUrlMap') {
                        for (var url in this.data.broadcastUrlMap) {
                            this.broadcastUrlMapTree[0].children.push({ 'label': url + ': ' + this.data.broadcastUrlMap[url] })
                        }
                        children.push(this.broadcastUrlMapTree[0])
                    }
                }
                if (!this.data.internal) {
                    if (this.data.topicHAInfo.modifiedTime) {
                        this.data.topicHAInfo.modifiedTime = new Date(parseInt(this.data.topicHAInfo.modifiedTime)).toLocaleString()
                    }
                    this.haTree[0].label = 'HAInfo'
                    this.appendContent(hachildren, this.data.topicHAInfo)

                    this.migrateTree[0].label = 'MigrateInfo'
                    if (this.data.topicMigrateInfo) {
                        if (this.data.topicMigrateInfo.createdTime) {
                            this.data.topicMigrateInfo.createdTime = new Date(parseInt(this.data.topicMigrateInfo.createdTime)).toLocaleString()
                        }
                        if (this.data.topicMigrateInfo.modifiedTime) {
                            this.data.topicMigrateInfo.modifiedTime = new Date(parseInt(this.data.topicMigrateInfo.modifiedTime)).toLocaleString()
                        }

                        this.appendContent(migratechildren, this.data.topicMigrateInfo)
                    }
                }
                getUserListById(response.ownerUserId).then(res => {
                    children.map(item => {
                        if (item.label === 'ownerUserId: ' + response.ownerUserId) {
                            item.label = item.label + '(:(' + res.name + ')'
                        }
                    })
                })
                this.dataTree[0].children = children
                this.haTree[0].children = hachildren
                this.migrateTree[0].children = migratechildren
                this.loading = false
            }).catch(() => {
                this.loading = false
            })
        },
        fetchRemain (queryRemain) {
            if (queryRemain) {
                this.remainLoading = true
            } else {
                this.loading = true
            }
            getTopicRemain(this.topicId, queryRemain).then(response => {
                this.list = response
                this.alreadyGetRemain = true
                if (queryRemain) {
                    this.remainLoading = false
                } else {
                    this.loading = false
                }
                this.showSubscribers = true
                this.batchVisible = false
                this.thVisible = false
            }).catch(() => {
                if (queryRemain) {
                    this.remainLoading = false
                } else {
                    this.loading = false
                }
            })
        },
        showTable () {
            this.fetchRemain(false)
            this.fetchRemain(true)
        },
        showPublisherTable () {
            this.dataList[0].leo = this.data.leo
            this.dataList[0].url = this.data.url
            this.dataList[0].mqType = this.data.mqType
            this.showPublishers = true
            this.refreshLeo()
        },
        refreshLeo () {
            this.loadingLeo = true
            getLeo(this.topicId).then(response => {
                this.dataList[0].leo = response.leo
                this.dataList[0].url = response.url
                this.dataList[0].mqType = response.mqType
                this.showPublishers = true
                this.loadingLeo = false
            }).catch(() => {
                this.loadingLeo = false
            })
        },
        setTime (row, column, cellValue, index) {
            let time = row[column.property]
            return new Date(parseInt(time)).toLocaleString()
        },
        renderContent (h, { node, data, store }) {
            if (node.label.indexOf('url: ') !== -1 || (this.data.broadcastUrlMap && Object.keys(this.data.broadcastUrlMap).indexOf(node.label.split(':')[0]) !== -1)) {
            return (
                <zm-form-item style="margin-bottom: 0;">
                    <span><b style="width: 200px;">{ node.label.split(': ')[0] }</b></span>
                    <a>&nbsp;{ node.label.split('(')[0].split(': ')[1] }</a>
                    <span><b style="width: 200px;">{ node.label.split('(:')[1] }</b></span>
                </zm-form-item>
            )
            } else {
            return (
                <zm-form-item style="margin-bottom: 0;">
                    <span><b style="width: 200px;">{ node.label.split(': ')[0] }</b></span>
                    <span>&nbsp;{ node.label.split('(')[0].split(': ')[1] }</span>
                    <span><b style="width: 200px;">{ node.label.split('(:')[1] }</b></span>
                </zm-form-item>
            )
            }
        },
        tableExpand (row, expandedRows) {
            // if (expandedRows.length) {
            //     this.$set(row, 'subscribersData', [])
            //     this.$set(row, 'subPageable', { pageNumber: 1, pageSize: 10, total: 0 })
            //     getTopicSubscriber(this.topicId, row.group, 10, 0).then(response => {
            //         row.subscribersData = response
            //     })
            // }
        },
        publisherTableExpand (row, expandedRows) {
            // if (expandedRows.length) {
            //     getTopicPublisher(this.topicId).then(res => {
            //         this.dataList[0].publishers = res
            //     })
            // }
        },
        showReset (row) {
            this.resetVisible = true
            this.resetForm.group = row.group
            this.resetForm.topicName = this.topicName
        },
        resetTopicRemain () {
            this.resetOffsetLoading = true
            resetTopicRemain(this.resetForm).then(response => {
                if (response.success) {
                    this.$message({
                        type: 'success',
                        message: 'Reset success'
                    })
                    this.resetOffsetLoading = false
                    this.resetVisible = false
                } else {
                    this.resetOffsetLoading = false
                    this.$message({
                        type: 'error',
                        message: response.errorMsg
                    })
                }
            })
        },
        batchSetSub (row) {
            this.batchForm.group = row.group
            this.batchForm.settingCounts = undefined
            this.batchForm.settingReceiveCounts = undefined
            this.batchForm.settingStatus = row.settingStatus
            this.batchVisible = true
        },
        openThreshold (row) {
            this.fetchClient()
            this.thForm.dcName = row.dcName
            this.thForm.group = row.group
            this.thForm.threshold = row.threshold
            this.thForm.settingConsumeDelayMs = row.settingConsumeDelayMs
            this.thForm.minWorkingCount = row.minWorkingCount
            this.thForm.shakeType = row.shakeType
            this.thForm.shakeValidPeriodMs = row.shakeValidPeriodMs
            this.thForm.consumerClientParamId = row.consumerClientParams ? row.consumerClientParams.id : ''
            this.thForm.discardUnhandledTask = row.discardUnhandledTask
            this.thForm.timeout = row.timeout
            this.thForm.timeoutIsSuccess = row.timeoutIsSuccess
            this.thForm.maxRetryTimes = row.maxRetryTimes
            this.thForm.retryInterval = row.retryInterval
            this.thForm.retryIntervalTimeUnit = row.retryIntervalTimeUnit
            this.thForm.version = row.version
            this.thVisible = true
        },
        showVerify (row) {
            this.verifyForm.group = row.group
            this.verifyForm.topicId = this.topicId
            this.verifyForm.subscriberIpVerify = row.subscriberIpVerify
            this.verifyForm.subscriberPrivateIpAllowStrings = row.subscriberPrivateIpAllowStrings || []
            this.verifyForm.subscriberPrivateIpDenyStrings = row.subscriberPrivateIpDenyStrings || []
            this.verifyForm.subscriberPublicIpAllowStrings = row.subscriberPublicIpAllowStrings || []
            this.verifyForm.subscriberPublicIpDenyStrings = row.subscriberPublicIpDenyStrings || []
            this.verifyVisible = true
        },
        saveVerify () {
            const { group, topicId, subscriberIpVerify } = this.verifyForm
            const subscriberPrivateIpAllowStrings = this.verifyForm.subscriberPrivateIpAllowStrings.join()
            const subscriberPrivateIpDenyStrings = this.verifyForm.subscriberPrivateIpDenyStrings.join()
            const subscriberPublicIpAllowStrings = this.verifyForm.subscriberPublicIpAllowStrings.join()
            const subscriberPublicIpDenyStrings = this.verifyForm.subscriberPublicIpDenyStrings.join()
            const data = { group, topicId, subscriberIpVerify, subscriberPrivateIpAllowStrings, subscriberPrivateIpDenyStrings, subscriberPublicIpAllowStrings, subscriberPublicIpDenyStrings }
            this.saveLoading = true
            updateSubscriptionIpVerify(data).then(response => {
                this.$message({
                    message: 'Update success!',
                    type: 'success'
                })
                this.fetchRemain(true)
                this.saveLoading = false
                this.verifyVisible = false
            }).catch(() => {
                this.saveLoading = false
            })
        },
        handleClose (tag, val) {
            this.verifyForm[val].splice(this.verifyForm[val].indexOf(tag), 1)
        },
        showInput (val) {
            this.tagVisible[val] = true
            this.$nextTick(_ => {
                this.$refs['saveTagInput_' + val][0].$refs.input.focus()
            })
        },
        handleInputConfirm (val) {
            var inputTagValue = this.tagInput[val]
            if (inputTagValue) {
                if (this.verifyForm[val].indexOf(inputTagValue) === -1) {
                    this.verifyForm[val].push(inputTagValue)
                } else {
                    this.$message({
                        type: 'warning',
                        message: 'Duplicated value'
                    })
                }
            }
            this.tagVisible[val] = false
            this.tagInput[val] = ''
        },
        saveBatch (isRefresh) {
            if (isRefresh) {
                this.resetLoading = true
            } else {
                this.saveLoading = true
            }
            batchSetSubscribers(this.batchForm).then(response => {
                this.$message({
                    message: 'Batch set subscribers success!',
                    type: 'success'
                })
                this.resetLoading = false
                this.saveLoading = false
                this.batchVisible = false
                // this.fetchRemain()
            }).catch(() => {
                this.resetLoading = false
                this.saveLoading = false
            })
        },
        batchResetSub () {
            this.$confirm('This will reset the subscribers. Continue?', 'Warning', {
                confirmButtonText: 'Reset',
                cancelButtonText: 'Cancel',
                type: 'warning'
            }).then(() => {
                this.batchForm.settingCounts = 0
                this.batchForm.settingReceiveCounts = 0
                this.batchForm.settingStatus = 'INITIAL'
                this.saveBatch(true)
            }).catch(() => {
                this.resetLoading = false
                this.saveLoading = false
                this.$message({
                    type: 'info',
                    message: 'Reset canceled'
                })
            })
        },
        saveThreshold () {
            this.$confirm('This will update the subscription. Continue?', 'Warning', {
                confirmButtonText: 'Set',
                cancelButtonText: 'Cancel',
                type: 'warning'
            }).then(() => {
                this.loading = true
                setThreshold(this.thForm).then(response => {
                    this.$message({
                        message: 'Set threshold success!',
                        type: 'success'
                    })
                    this.loading = false
                    this.thVisible = false
                    this.fetchRemain(false)
                }).catch(() => {
                    this.loading = false
                })
            }).catch(() => {
                this.loading = false
                this.$message({
                    type: 'info',
                    message: 'Set canceled'
                })
            })
        },
        deleteSub (row) {
            this.loading = true
            this.$confirm('This will permanently delete the subscription. Continue?', 'Warning', {
                confirmButtonText: 'Delete',
                cancelButtonText: 'Cancel',
                type: 'warning'
            }).then(() => {
                deleteSubscriber(row.topicId, row.group).then(response => {
                    this.loading = false
                    this.fetchRemain(false)
                    getTopicById(this.topicId).then(response => {
                        this.data = response
                    })
                    this.$message({
                        message: 'Delete subscriber success!',
                        type: 'success'
                    })
                }).catch(() => {
                    this.loading = false
                })
            }).catch(() => {
                this.loading = false
                this.$message({
                    type: 'info',
                    message: 'Delete canceled'
                })
            })
        },
        refreshSubscriberList () {
            this.fetchRemain()
            getTopicById(this.topicId).then(response => {
                this.data = response
            })
        },
        downloadSubscribers () {
            downloadSubcribers(this.topicId).then((res) => {
                let blob = new Blob([res], { type: 'application/vnd.ms-excel' })
                var a = document.createElement('a')
                a.href = URL.createObjectURL(blob)
                a.download = this.topicName + '_subscribers_data.xlsx'
                a.style.display = 'none'
                document.body.appendChild(a)
                a.click()
                a.remove()
            })
        },
        downloadProducers () {
            downloadProducers(this.topicId).then((res) => {
                let blob = new Blob([res], { type: 'application/vnd.ms-excel' })
                var a = document.createElement('a')
                a.href = URL.createObjectURL(blob)
                a.download = this.topicName + '_producers_data.xlsx'
                a.style.display = 'none'
                document.body.appendChild(a)
                a.click()
                a.remove()
            })
        }
    }
}
</script>
<style scoped>
@import '../../assets/icons/iconfont.css';
.zm-tree-node__content {
    height: 28px;
}
.table-in-detail {
    margin: 40px 0;
}
.detail-container {
    margin-right: 20px;
}
</style>
<style>
#subscriber-table .zm-table__column-setting {
    right: 1px;
}
.zm-table th a, .zm-table td a {
    color: #0E71EB;
    font-weight: inherit;
}
.select-with-number {
    width: 110px;
}
.select-with-number .zm-select-input {
    border-radius: 0 8px 8px 0;
}
.select-with-number.zm-select {
    border-radius: 0 8px 8px 0;
}
.zm-table-column-panel__group-list {
    max-height: 60vh;
    overflow-y: scroll;
}
.input-tag {
  margin-right: 10px;
  padding:  0 20px 0 10px;
}
.input-new-tag.zm-input {
  width: 200px;
  vertical-align: baseline;
}
/* .zm-tag + .zm-tag {
    margin-left: 10px;
} */
.button-new-tag {
    /* margin-left: 10px; */
    height: 32px;
    line-height: 30px;
    padding-top: 0;
    padding-bottom: 0;
}
.input-new-tag {
    width: 90px;
    /* margin-left: 10px; */
    vertical-align: bottom;
}
</style>
